import createVueComponent from '../createVueComponent';

const ReplyAll = createVueComponent('ReplyAllIcon', [
  ['polyline', { points: '7 17 2 12 7 7' }],
  ['polyline', { points: '12 17 7 12 12 7' }],
  ['path', { d: 'M22 18v-2a4 4 0 00-4-4H7' }],
]);

export default ReplyAll;
